/** @jsx jsx */

import { jsx } from '@balance-web/core';
import type { HelpIndicatorProps } from '@balance-web/tooltip';
import { HelpIndicator as BaseHelpIndicator } from '@balance-web/tooltip';

import { useMaybeFieldContext } from './context';

/**
 * Re-exported from `@balance-web/tooltip` (its canonical home) with one
 * addition: inside a `Field`, the testid falls back to the field's id.
 */
export const HelpIndicator = (props: HelpIndicatorProps) => {
  const fieldContext = useMaybeFieldContext();

  return <BaseHelpIndicator {...props} id={props.id ?? fieldContext?.id} />;
};
